var map = {
	"./assets/clickable/amazon.svg": "1e3f273d19e5ead564fa",
	"./assets/disabled/amazon.svg": "4cfa13dd6539a1afc246",
	"./assets/original/amazon.svg": "8dc09a0ad8e9739753d4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e7cd09ec92f276c22475";